import { useEffect } from 'react';

export const useTitle = (title = 'Shell Battery Management Hub') => {
  useEffect(() => {
    document.title = title;
  }, []);
};

export default useTitle;
